import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentAccountId: 'getCurrentAccountId',
    }),
  },
  methods: {
    hasModule(moduleName) {
      const accountId = this.currentAccountId || this.$route.params.accountId;
      const account = this.$store.getters['accounts/getAccount'](accountId);

      if (!account) return false;

      const inEnabledModules =
        account.enabled_modules &&
        (account.enabled_modules[moduleName] === true ||
          account.enabled_modules[moduleName] === 'true');

      let inFeatures = false;
      if (account.features) {
        if (Array.isArray(account.features)) {
          inFeatures = account.features.includes(moduleName);
        } else {
          inFeatures =
            account.features[moduleName] === true ||
            account.features[moduleName] === 'true';
        }
      }

      return inEnabledModules || inFeatures;
    },
  },
};
